import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "create_time" }
const _hoisted_2 = {
  key: 0,
  class: "active_collapse_icon"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["src"]

import { computed, ref} from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'

interface MessageData {
    content: string
    createTime: string
    status: number
}

export default /*@__PURE__*/_defineComponent({
  __name: 'messageCard',
  props: {
    messageData: {},
    title: {},
    attachement: {}
  },
  emits: ['openMessageContent'],
  setup(__props: any, { emit: __emit }) {

const userStore = useUserStore()
const isExpanded = ref(false)
const emits = __emit
const router = useRouter()
const props = __props
const fullMessage = ref(props.messageData.content)

const displayedMessage = computed(() =>
    isExpanded.value ? fullMessage : fullMessage.value.split('\n')[0]
)

const toggleExpand = () => {
    userStore.setReadMessage({
      ...props.messageData,
      title: props.title,
      attachment: props.attachement
    })
     emits('openMessageContent')
}


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(isExpanded.value ? 'active_card' : 'card_container'),
      onClick: toggleExpand
    }, [
      _createVNode(_component_van_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: "20" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "title",
                style: _normalizeStyle({ color: isExpanded.value ? '#fff' : '' })
              }, _toDisplayString(_ctx.$t(props.title || '')), 5),
              _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.messageData.createTime), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "4",
            class: "icon_container"
          }, {
            default: _withCtx(() => [
              (_ctx.messageData.status == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        class: _normalizeClass(["msg_content", { collapsed: !isExpanded.value }]),
        style: _normalizeStyle({ fontWeight: isExpanded.value ? 'bold' : '' })
      }, _toDisplayString(displayedMessage.value), 7),
      (isExpanded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _ctx.attachement,
              width: "30%",
              alt: ""
            }, null, 8, _hoisted_4)
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})